import React, { useEffect } from 'react';
import { useColorMode, useColorModeValue } from '@chakra-ui/react';
import Header from 'components/Header';
import EspecialidadesModule from 'modules/EspecialidadesModule';
import { DefaultPageContainer, ContentContainer, LeftContainer } from '../../styles/DefaultPage.styles';

const Especialidades: React.FC = () => {
  const { toggleColorMode } = useColorMode();
  const currentTheme = useColorModeValue('light', 'dark');

  useEffect(() => {
    //console.log('Atendimento page loaded');
  }, []);

  return (
    <>
      <Header
        theme={currentTheme}
        toggleTheme={toggleColorMode}
      />
      <DefaultPageContainer>
        <ContentContainer>
          <LeftContainer>
            <EspecialidadesModule />
          </LeftContainer>
        </ContentContainer>
      </DefaultPageContainer>
    </>
  );
};

export default Especialidades;
